module.exports = __webpack_public_path__ + "img/folder.221e8944.jpg";